import { ISnotrRoute } from '..';

export default [
  {
    path: '/pension-companies',
    name: 'PensionUnitSelections',
    meta: {
      title: 'TabTitle.pensionUnitSelections',
      applicationMode: 'PaycheckMode',
    },
    component: () => import('@/pages/pension-unit-selections.vue'),
  },
] as ISnotrRoute[];
